import Vue from 'vue'
import App from './App'
import router from '@router'
import store from '@state/store'
import '@components/_globals'

import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'
import vco from 'v-click-outside'
import VueRouter from 'vue-router'
import VueFeather from 'vue-feather'
import flatPickr from 'vue-flatpickr-component'
import VueToastr from 'vue-toastr'
import axios from 'axios'
import VueAxios from 'vue-axios'
import jQuery from 'jquery'
// Import loading indicator component
import Loading from 'vue-loading-overlay'
import appConfig from '@src/app.config'

Vue.use(VueFeather)
Vue.use(flatPickr)

Vue.use(VueRouter)
Vue.use(vco)

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// Helper function to log errors to backend
function logErrorToBackend(errorData) {
  try {
    axios.post(`${appConfig.apiDomain}/error-log`, errorData, {
      timeout: 3000,
    }).catch(() => {
      // Silently fail if error logging fails
    })
  } catch (e) {
    // Silently fail if error logging fails
  }
}

// Global error handler for Vue errors
Vue.config.errorHandler = (err, vm, info) => {
  // If running inside Cypress, use Cypress handler
  if (process.env.VUE_APP_TEST === 'e2e' && window.Cypress) {
    window.Cypress.cy.onUncaughtException(err)
    return
  }

  const errorData = {
    message: err.message || 'Vue Error',
    error: err.toString(),
    stack: err.stack || '',
    url: window.location.href || '',
    userAgent: navigator.userAgent || '',
    timestamp: new Date().toISOString(),
    componentInfo: info || '',
    vueComponent: (vm && vm.$options && vm.$options.name) || (vm && vm.$options && vm.$options.__file) || '',
  }

  logErrorToBackend(errorData)
  console.error('Vue Error:', err, info)
}

// Global error handler for unhandled errors
window.onerror = (message, source, lineno, colno, error) => {
  const errorData = {
    message: message || 'Unhandled Error',
    error: (error && error.toString()) || message,
    stack: (error && error.stack) || `at ${source}:${lineno}:${colno}`,
    url: window.location.href || '',
    userAgent: navigator.userAgent || '',
    timestamp: new Date().toISOString(),
    source: source || '',
    lineno: lineno || '',
    colno: colno || '',
  }

  logErrorToBackend(errorData)
  console.error('Global Error:', message, source, lineno, colno, error)
}

// Global handler for unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  const error = event.reason
  const errorData = {
    message: 'Unhandled Promise Rejection',
    error: (error && error.message) || (error && error.toString()) || 'Unknown promise rejection',
    stack: (error && error.stack) || '',
    url: window.location.href || '',
    userAgent: navigator.userAgent || '',
    timestamp: new Date().toISOString(),
    promise: (error && error.toString()) || '',
  }

  logErrorToBackend(errorData)
  console.error('Unhandled Promise Rejection:', error)
})

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(VueAxios, axios)

// Init loading indicator  plugin
var loadingConfig = { color: '#007bff', loader: 'dots' }
Vue.use(Loading, loadingConfig)

window.jQuery = jQuery
window.$ = jQuery
Vue.component('apexchart', VueApexCharts)

// use plugin
Vue.use(VueToastr, {
  /* OverWrite Plugin Options if you need */
})
// Uncomment this if you are having api served through other url or do not want to use fake backend
// Vue.prototype.$http = require('axios')
// Vue.prototype.$http.defaults.baseURL  = 'http://mock-api.coderthemes.com/'

const app = new Vue({
  router,
  store,
  mounted() {
    this.$toastr.defaultPosition = 'toast-bottom-right'
  },
  render: (h) => h(App),
}).$mount('#app')

// If running e2e tests...
if (process.env.VUE_APP_TEST === 'e2e') {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}
